// Lista dei TEMPLATE (scheletro/composizione) per il popup di scelta in Console.
// ⚠️ Gli ID DEVONO combaciare con templates/restaurant/site/src/config/templates.ts
// e con TEMPLATE_IDS in apps/api/src/routes/admin.ts. `preview` serve solo a
// disegnare la mini-card; il template è scelto dall'OPERATORE (non dal cliente).

export interface TemplatePreview {
  vibe: 'classico' | 'lampo' | 'carta' | 'marea'; // quale mini-anteprima disegnare
  bg: string; // fondo
  bar: string; // barra/insegna (o titolo per classico)
  accent: string; // accento (bottone/bollo)
  ink: string; // testo
}

export const DESIGN_TEMPLATES: { id: string; label: string; suited: string; preview: TemplatePreview }[] = [
  {
    id: 'classico',
    label: 'Classico',
    suited: 'Versatile — testata + sezioni in ordine, adatto a quasi tutti',
    preview: { vibe: 'classico', bg: '#FBF7EF', bar: '#2F3D2E', accent: '#B0833C', ink: '#26241D' },
  },
  {
    id: 'lampo',
    label: 'Lampo',
    suited: 'Hamburgeria · street food · finger food (audace, kinetico)',
    preview: { vibe: 'lampo', bg: '#141210', bar: '#E2402A', accent: '#F2C200', ink: '#F2EDE3' },
  },
  {
    id: 'carta',
    label: 'Carta',
    suited: 'Editoriale audace · braceria · fine dining · cucina d\'autore (carta, grottesco, rosso)',
    preview: { vibe: 'carta', bg: '#e7e2d6', bar: '#bd2f23', accent: '#bd2f23', ink: '#16140f' },
  },
  {
    id: 'marea',
    label: 'Marea',
    suited: 'Immersivo cinematografico · cucina di mare · pesce · locali vista mare (hero a tutto schermo, scuro, slideshow)',
    preview: { vibe: 'marea', bg: '#0b1a26', bar: '#0a1f30', accent: '#c9a24b', ink: '#f4efe4' },
  },
];
